import { Col, Modal, Row, Switch } from 'antd'
import React, { useEffect, useState } from 'react'
import Input from 'components/ui/dataEntry/inputs/Input'
import MultipleDropDown from '../inputs/MultipleDropDown'
import { isEmpty } from 'lodash'
import { getAssetTypesNameArray } from 'components/ui/dataDisplay/utils'
import { ADD_VAM_ASSET_TYPE_DROPDOWN_KEY_TYPE, SPECIAL_CHARACTER_REGEX } from 'constants/general-constants'
import './AddEditVirtualModuleModal.scss'

const AddEditVirtualManagerModal = ({
  visible,
  onOk,
  onCancel,
  confirmLoading,
  isEditMode,
  fieldData,
  project,
  assetList
}) => {
  const [isActive, setIsActive] = useState(false)
  const [title, setTitle] = useState('')
  const [assetTypes, setAssetTypes] = useState([])
  const titleHasSpecialCharacters = !SPECIAL_CHARACTER_REGEX.test(title)
  const clearAllFields = () => {
    setAssetTypes([])
    setTitle('')
    setIsActive(false)
  }
  const isSubmitButtonDisabled = ({ title, assetTypes, titleHasSpecialCharacters }) => {
    if (!title || isEmpty(assetTypes) || titleHasSpecialCharacters) return true
    return false
  }

  useEffect(() => {
    if (!isEmpty(fieldData) && isEditMode && !isEmpty(assetList)) {
      setTitle(fieldData?.title)
      const assetTypeList = fieldData?.assetTypes?.map(item => {
        return {
          [ADD_VAM_ASSET_TYPE_DROPDOWN_KEY_TYPE]: item
        }
      }) || []
      setAssetTypes(assetTypeList)
      setIsActive(fieldData?.isActive)
    }
  }, [fieldData, isEditMode, assetList])
  return (
    <Modal
      title={isEditMode ? 'Edit Virtual Asset Manager' : 'Add Virtual Asset Manager'}
      visible={visible}
      onOk={() => {
        let variables = {
          title,
          assetTypes: getAssetTypesNameArray(assetTypes, ADD_VAM_ASSET_TYPE_DROPDOWN_KEY_TYPE),
          project,
          isActive,
          isArchived: false,
          clearAllFields
        }
        if (isEditMode) {
          variables = {
            id: fieldData?.id,
            assetTypes: getAssetTypesNameArray(assetTypes, ADD_VAM_ASSET_TYPE_DROPDOWN_KEY_TYPE),
            project,
            title,
            isActive,
            isArchived: false,
            clearAllFields
          }
        }
        onOk(variables)
      }}
      onCancel={() => {
        onCancel()
        clearAllFields()
      }}
      className='general-modal add-edit-virtual-module-modal'
      okText='Save'
      cancelText='Cancel'
      okButtonProps={{
        disabled: isSubmitButtonDisabled({ title, confirmLoading, assetTypes, titleHasSpecialCharacters })
      }}
      confirmLoading={confirmLoading}
      getContainer={document.getElementById('admin-list')}
      maskClosable={false}
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Input
            title='Title'
            placeholder='Enter Title'
            inputName='title'
            isRequired
            value={title}
            handleChange={(e) => {
              setTitle(e.target.value)
            }}
            isError={titleHasSpecialCharacters}
            errorMessage={titleHasSpecialCharacters && 'Please remove special characters'}
          />
        </Col>
        <Col span={24} >
          <label>Asset Types <span className='mandatory'>*</span></label>
          <MultipleDropDown
            options={assetList || []}
            displayParam={ADD_VAM_ASSET_TYPE_DROPDOWN_KEY_TYPE}
            keyParam={ADD_VAM_ASSET_TYPE_DROPDOWN_KEY_TYPE}
            placeHolder='Select Asset Types'
            parent='admin-list'
            selectedValue={assetTypes}
            onOptionSelect={(value) => setAssetTypes(value)}
            allowClear
          />
        </Col>
        <Col span={24}>
          <div className='switch-inner-container'>
            <p>Active</p>
            <Switch
              checked={isActive}
              onChange={(flag) => setIsActive(flag)}
            />
          </div>
        </Col>
      </Row>
    </Modal>
  )
}

export default AddEditVirtualManagerModal
